module.exports = __webpack_public_path__ + "static/Hyperstate_WebIllustration.4b6d5e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Hyperstate_WebIllustration.png
// module id = 472
// module chunks = 54899801262779